import { Subtitle2, useTheme } from "capsule"
import React, { FC, PropsWithChildren, useMemo } from "react"
import { StyleSheet, View } from "react-native"
interface IProps {
  label: string
  value: string
}

const LastEvalItem: FC<PropsWithChildren<IProps>> = ({ children, label, value }) => {
  const {
    fontMaker,
    dimensions: { spacing },
    colors: {
      surface: { card },
    },
  } = useTheme()

  const s = useMemo(
    () => ({
      item: [
        styles.item,
        {
          paddingVertical: spacing / 2,
          backgroundColor: card,
        },
      ],
      image: {
        marginVertical: spacing / 2,
      },
      evalText: [fontMaker({ weight: "Bold" })],
    }),
    [spacing, fontMaker, card],
  )

  return (
    <View style={s.item}>
      <Subtitle2 style={s.evalText}>{label}</Subtitle2>
      <View style={s.image}>{children}</View>
      <Subtitle2 style={s.evalText}>{value}</Subtitle2>
    </View>
  )
}

const styles = StyleSheet.create({
  item: {
    alignItems: "center",
    borderRadius: 8,
    width: "30%",
  },
})

export default LastEvalItem
